import { useContext } from 'react';
import DocumentContext from '../../../contexts/DocumentContext.context';
import ToolbarToggleButton from '@modules/documents/components/header/toolbar/ToolbarToggleButton';
import { wrapLikeWord } from './utils/rowWrap';
import { unwrapLikeWord } from './utils/rowUnwrap';
import { getRowAction, isInRow } from './utils/rowAvailability';
import WrapToggleIcon from './WrapToggleIcon';
import useEditorActive from '../../../hooks/useEditorActive.hook';

const WrapToggleButton = () => {
  const { editor } = useContext(DocumentContext);

  const action = useEditorActive((editor) => getRowAction(editor.state));
  const isGrouped = useEditorActive((editor) => isInRow(editor.state));

  const onClick = () => {
    if (!action.kind) return;
    if (action.kind === 'unwrap') {
      editor.chain().focus().command(unwrapLikeWord()).run();
    } else {
      editor.chain().focus().command(wrapLikeWord()).run();
    }
  };

  const label = action.kind === 'unwrap' ? 'Unwrap' : 'Wrap';
  const disabled = !action.kind;
  const tooltip = action.tooltip;

  return (
    <ToolbarToggleButton
      selector={false}
      disabled={disabled} // disable if neither action is allowed
      onClick={onClick}
      icon={<WrapToggleIcon />}
      tooltip={tooltip}
    >
      {label}
    </ToolbarToggleButton>
  );
};

export default WrapToggleButton;
